<template>
        <div class="col-xl-6 col-12 d-flex flex-wrap justify-content-center justify-content-xl-start align-content-start align-items-start mt-md-4 mt-xl-0">
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-0" >
                Ciudad
            </div>
            <div class="col-xxl-8 col-10 d-flex justify-content-start align-content-start align-items-start ps-xl-4 ps-2">
                <select autocomplete='off' spellcheck='false' autocorrect='off' class="w-100 inputText t-xxl-3 t-16 t-sm-11 t-xl-8" v-model="formFields.step7.cityIndex" @change="setValue('step7', 'cityIndex', $event.target.value);setValue('step7', 'cityName', cities[$event.target.value].dCiudad);setValue('step7', 'storeId', cities[$event.target.value].storeNumber)">
                    <option value="" disabled selected>Selecciona una ciudad</option>
                    <option :value="ctidx" v-for="(city, ctidx) in cities" :key="ctidx">{{city.dCiudad}}</option>
                </select>
            </div>
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-5">
                Sucursal
            </div>
            <div class="col-xxl-8 col-10 d-flex justify-content-start align-content-start align-items-start ps-xl-4 ps-2" :class="formFields.step7.cityIndex != '' ? '' : 'pe-none opacity-50'">
                <select :tabindex="formFields.step7.cityIndex != '' ? '' : '-1  '" spellcheck='false' autocorrect='off' class="w-100 inputText t-xxl-3 t-16 t-sm-11 t-xl-8" v-model="formFields.step7.storeId" @change="setValue('step7', 'storeId', $event.target.value)">
                    <option value="" disabled selected>Selecciona una sucursal</option>
                    <template v-if="cities.length > 0 && formFields.step7.cityIndex != ''">
                        <option :value="skey" v-for="(store, skey, sidx) in cities[formFields.step7.cityIndex].stores" :key="sidx">{{store.name}}</option>
                    </template>
                </select>
            </div>
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-5">
                Medio de pago
            </div>
            <div class="col-xxl-8 col-10 d-flex justify-content-start align-content-start align-items-start ps-xl-4 ps-2">
                <select autocomplete='off' spellcheck='false' autocorrect='off' class="w-100 inputText t-xxl-3 t-16 t-sm-11 t-xl-8" v-model="formFields.step7.payForm" @change="setValue('step7', 'payForm', $event.target.value)">
                    <option value="cash">Efectivo</option>
                    <option value="card">Tarjeta</option>
                </select>
            </div>
            <div class="col-xxl-8 col-10 d-flex flex-wrap justify-content-center justify-content-xl-start align-content-start align-items-start mt-0"  v-if="formFields.step7.storeId != '' && formFields.step7.cityIndex != '' && cities.length > 0">
                <div class="w-100 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-5">
                    Articulo
                </div>
                <div class="w-100 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-3 mt-xl-2 ps-xl-4 ps-2">
                    <div class="w-100 d-flex flex-wrap justify-content-center align-content-start align-items-start">
                        <div class="subtitleOption t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 mb-2">1 - Giftcard </div><div class="dataImport t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 text-end text-xl-start">$ {{this.formFields.step1.amount.value}}</div>
                        <div class="subtitleOption t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 mb-2">Fecha de entrega:</div><div class="dataImport t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 text-end text-xl-start">{{this.formFields.step3.receiverDate.date}}</div>
                        <div class="subtitleOption t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 mb-2">Destinatario:</div><div class="dataImport t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 text-end text-xl-start"><div class="w-100">{{capitalizeWords(this.formFields.step1.receiverName)}}</div><div class="w-100">{{this.formFields.step2.receiverWhatsapp}}</div></div>
                        <div class="subtitleOption t-16 t-sm-13 t-xl-7 t-xxl-4 col-6">Remitente:</div><div class="dataImport t-16 t-sm-13 t-xl-7 t-xxl-4 col-6 text-end text-xl-start"><div class="w-100">{{capitalizeWords(this.formFields.step4.senderName)}}</div><div class="w-100">{{this.formFields.step4.senderWhatsapp}}</div></div>
                    </div>
                </div>
                <div class="w-100 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-3 mt-xl-3 d-flex justify-content-end">
                    <button class="generalButton t-xl-12 t-xxl-8 t-30 t-sm-24 w-100 w-md-auto mt-4" @click="validateNextness()">Solicitar</button>
                </div>
            </div>
        </div>

</template>

<script>
import whatsAppView from '@/components/whatsAppView.vue'

export default {
    name: 'step7',
    emits:['setData', 'progress', 'showModal', 'setLoading', 'sendOrder'],
    components:{
        whatsAppView
    },
    props: {
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        },
        formFields: {},
        cities:{
            default:[],
            type: Array
        }
    },
    methods:{
        validateNextness(){
            this.$emit('setLoading', true);
            this.$emit('sendOrder');
        },
        setValue(step, field, value){
            let form = this.formFields[step];
            form[field] = value;
            this.$emit('setData', form, step);
        },
        step(step){
            this.$emit('progress', step);
        }
    },
    data() {
        return {
            simbol:require('@/assets/images/a27.svg'),
        }
    }
}
</script>

<style scoped lang="css">
.titleOption{
    color: var(--primary);
    font-weight: 600;
}
.cardDisabled .titleOption{
    opacity:0.5;
    pointer-events: none;
}
.cardDisabled input{
    opacity:0.5;
    pointer-events: none;
}
.subtitleOption{
    color: var(--sexagenary);
}
.inputText{
    border: 2px solid var(--quartenary);
    border-radius: 12px;
    padding: 13px;
    height: 50px;
    color: var(--primary);
}
.inputText{
    outline: none;
}
textarea{
    resize: none;
}
.linkChange{
    color: var(--septagenary);
    cursor: pointer;
    font-weight: 700;
}
.linkChange:hover{
    color: var(--primary);
}

.commonPageCheckbox input:not(:checked) + label:hover{
    border:5px solid var(--secondary);
}
.commonPageCheckbox input:not(:checked) + label>span{
    display: none;
}
.commonPageCheckbox input{
    display: none;
}
.commonPageCheckbox label{
    cursor:pointer;
    width: 30px;
    height: 30px;
    border:3px solid var(--quinary);
    border-radius: 6px;
    overflow: visible;
}
.commonPageCheckbox img{
    width: 100%;
    height: 100%;
    margin-left: 15%;
    transform: scaleX(2.2) scaleY(2.2) translateY(-10%);
}
.commonPageCheckbox span{
    background-color: transparent;
}
.titleOption2{
    color: var(--primary);
    font-weight: 600;
}
.subtitleOption2{
    color: var(--sexagenary);
}
@media (min-width: 768px) {
    .commonPageCheckbox label{
        border:5px solid var(--quinary);
        width: 40px;
        height: 40px;
    }
}
</style>
